import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).find("input[data-toggle='toggle']").bootstrapToggle()
  }
}
